import { render, staticRenderFns } from "./AppFeatureBadge.global.vue?vue&type=template&id=5bca7910&"
import script from "./AppFeatureBadge.global.vue?vue&type=script&lang=js&"
export * from "./AppFeatureBadge.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports